import { ZfStack, ZfToggle, ZfTypography } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { useEffect, useState } from 'react';
import { useSurplusSettings, useUpdateSurplusOverride } from '../../../api';

interface IProps {
    cashflowSettingsEnabled: boolean;
    label: string;
    isCustomLabel?: boolean;
}

export const SurplusOverrideToggle: FunctionComponent<IProps> = ({ cashflowSettingsEnabled, label, isCustomLabel }) => {
    const [isToggled, setIsToggled] = useState(cashflowSettingsEnabled);
    const { data: surplusSettings } = useSurplusSettings();
    const updateSurplusOverrideSettings = useUpdateSurplusOverride();

    useEffect(() => {
        if (surplusSettings) setIsToggled(!!surplusSettings.enabled);
    }, [surplusSettings]);

    const handleToggle = (event: CustomEvent<boolean>) => {
        setIsToggled(event.detail);

        updateSurplusOverrideSettings.mutate({ ...surplusSettings, enabled: event.detail }, { onError: () => setIsToggled(!event.detail) });

        event.stopPropagation();
    };

    return (
        <ZfStack direction="row" alignment="center" justify="space-between">
            {isCustomLabel && (
                <ZfTypography variant="body-small" color="normal">
                    {label}
                </ZfTypography>
            )}
            <ZfToggle label={isCustomLabel ? '' : label} checked={isToggled} onToggleChange={handleToggle} disabled={!cashflowSettingsEnabled} />
        </ZfStack>
    );
};
